export default __webpack_public_path__ + "static/media/whatsapp.9abceef3.png";